import ThemeButton from "components/Buttons/ThemeButton";
import { styled } from "@mui/material";

export const Container = styled("div")<{ scale: number }>`
	width: 343px;
	background-color: #fff;
	border-radius: 1rem;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
`;

export const Header = styled("div")<{ "data-image": string }>`
	height: 188px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-position: center;
	background-image: url(${(props) => props["data-image"]});
	position: relative;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 258px;
		height: auto;
	}
`;

export const Avatar = styled("img")`
	object-fit: contain;
	position: absolute;
	bottom: 12px;
	left: 20%;
`;

export const Tresure = styled("img")`
	object-fit: contain;
	position: absolute;
	bottom: -12px;
	left: 28%;
`;

export const Body = styled("div")`
	max-width: 372px;
	margin: 0 auto;
	padding: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
`;

export const Title = styled("span")`
	font-family: "Baloo";
	font-size: 20px;
	text-align: center;
	color: #113b62;
	line-height: 22px;
`;

export const Text = styled("p")`
	font-family: "Inter";
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 0;
	line-height: 21px;
`;

export const SubTitle = styled("p")`
	font-family: "Baloo";
	font-size: 15px;
	color: ${(props) => props.color || "#fff"};
	line-height: 122%;
	text-shadow: 1.58px 1.58px 0px #000;
	-webkit-text-stroke-width: 3.08px;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	margin: 0;
	letter-spacing: 0.5px;
`;

export const FirstTimePurchaseContainer = styled("div")`
	width: calc(100% - 30px);
	background-color: rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(14.08px);
	border-radius: 16px;
	padding: 8px 15px;
`;

export const Button = styled(ThemeButton)`
	padding: 0.5rem;
`;
